var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "168px",
    height: "118px",
    viewBox: "0 0 168 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Customer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 168,
    height: 118
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(29.974359, 7.695652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.002194,58.0773341 C71.4961201,57.9257938 70.9640566,57.8919971 70.4446269,57.9686757 C70.3839847,57.9657685 70.3229814,57.9643149 70.2623392,57.961771 C74.9480353,53.3530587 77.8646383,46.9284076 77.8646383,39.8281851 L77.8646383,3.63405797 C77.8646383,1.62733116 76.2482338,0 74.2549811,0 L47.5164451,0 C36.4647575,0 27.4734622,9.052075 27.4734622,20.1784703 L27.4734622,39.8278217 C27.4734622,46.9280442 30.3900653,53.3526953 35.0757614,57.9614076 C35.0151191,57.9639514 34.9541159,57.9654051 34.8934737,57.9683123 C34.374405,57.8919971 33.8419805,57.9254304 33.3359066,58.0769707 C14.6754225,59.763537 0,75.5931301 0,94.8114822 L0,105.928681 C0,107.935408 1.61640451,109.562739 3.60965724,109.562739 L101.728804,109.562739 C103.722057,109.562739 105.338462,107.935408 105.338462,105.928681 L105.338462,94.8118457 C105.338462,75.5938569 90.6626781,59.7639004 72.002194,58.0773341 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "#0057B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6920548,20.1784703 C34.6920548,13.0597141 40.4451265,7.26811594 47.5157231,7.26811594 L70.6446019,7.26811594 L70.6446019,16.9932185 C70.6446019,21.9071917 66.673618,25.9050188 61.7926395,25.9050188 L34.6920548,25.9050188 L34.6920548,25.2686953 L34.6920548,20.1784703 Z",
    id: "Path",
    stroke: "#CCE3FD",
    strokeWidth: 4,
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6920548,39.8281851 L34.6920548,33.1731348 L61.7926395,33.1731348 C65.061906,33.1731348 68.1041251,32.182854 70.6446019,30.4882928 L70.6446019,39.8278217 C70.6446019,49.8069449 62.5802667,57.9257938 52.6681479,57.9257938 C42.7560291,57.9257938 34.6920548,49.8073083 34.6920548,39.8281851 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "62.2550365 65.1939098 52.6685088 74.8452409 43.0819811 65.1939098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1184251,102.205857 L7.21859256,102.205857 L7.21859256,98.5629203 L7.43336716,91.2948043 C9.02883566,77.7881011 19.6841829,67.0461891 33.0933376,65.4166775 L50.1161202,82.5545315 C50.8210863,83.2638996 51.7447975,83.6189471 52.6685088,83.6189471 C53.5922201,83.6189471 54.5159314,83.2638996 55.2208975,82.5545315 L72.2436801,65.4166775 C86.798901,67.1853736 98.1184251,79.6890768 98.1184251,94.8118457 L98.1184251,102.205857 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6808073,103.915647 L5.58966109,103.870455 L5.58966109,100.424122 C5.58966109,97.448014 5.58966109,95.2159326 5.58966109,93.7278784 C5.58966109,92.9956335 5.84177856,89.7547957 6.02820577,88.8774351 C7.09558167,83.8541686 9.42446676,78.8313602 12.6894936,74.8452409 C17.5000676,68.9722351 25.7985214,64.5177237 33.2593949,63.6110611 C33.4697412,63.6110611 28.2265651,67.5312715 25.3255412,71.5076523 C23.20062,74.4202434 22.3491002,75.5920419 20.7094233,79.223378 C18.9258711,83.1733495 18.2496658,91.4041059 18.6808073,103.915647 Z",
    id: "Path-Copy-20",
    fill: "#CCE3FD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    opacity: 0.8,
    transform: "translate(31.687179, 28.217391)",
    fill: "#0079FF",
    fillOpacity: 0.20902535,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66943564,18.3503777 L8.66943564,0.901724156 C7.72294151,0.901724156 0.0758016517,-0.799378072 0.0758016517,2.27090145 C0.0758016517,6.96414065 0.342334404,12.322224 0.875399909,18.3451516 C0.875399909,25.3848829 15.0912678,31.8215636 18.2507621,32.5846949 C20.3570916,33.093449 22.5521368,33.093449 24.8358974,32.5846949 C17.7992887,32.5846949 8.66943564,25.3873048 8.66943564,18.3503777 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 70.225641,
    y: 102.608696,
    width: 13.7025641,
    height: 6.84057971,
    rx: 3.42028986
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6282486,104.206539 L71.9717514,104.206539 C72.8993306,104.206539 73.6512821,104.95849 73.6512821,105.88607 C73.6512821,106.813649 72.8993306,107.5656 71.9717514,107.5656 L61.6282486,107.5656 C60.7006694,107.5656 59.9487179,106.813649 59.9487179,105.88607 C59.9487179,104.95849 60.7006694,104.206539 61.6282486,104.206539 Z",
    id: "Rectangle-Copy",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6105794,104.205623 L89.9586513,104.205623 C90.8849688,104.205623 91.6358974,104.956552 91.6358974,105.88287 C91.6358974,106.809187 90.8849688,107.560116 89.9586513,107.560116 L79.6105794,107.560116 C78.684262,107.560116 77.9333333,106.809187 77.9333333,105.88287 C77.9333333,104.956552 78.684262,104.205623 79.6105794,104.205623 Z",
    id: "Rectangle-Copy-2",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0057B8",
    x: 59.9487179,
    y: 83.7971014,
    width: 5.13846154,
    height: 5.13043478,
    rx: 2.56521739
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 35.1128205,
    y: 16.2463768,
    width: 2.56923077,
    height: 10.2608696,
    rx: 1.28461538
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-5",
    transform: "translate(41.107692, 7.695652)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85927179,5.82817391 C4.40794359,5.82817391 4.04054359,6.19414493 4.04054359,6.64562319 L4.04054359,8.54131884 C4.04054359,8.9927971 4.40794359,9.35791304 4.85927179,9.35791304 C5.3106,9.35791304 5.678,8.9927971 5.678,8.54131884 L5.678,6.64562319 C5.678,6.19414493 5.3106,5.82817391 4.85927179,5.82817391",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71738974,3.92649275 L0.817871795,3.92649275 C0.36654359,3.92649275 -3.65109652e-14,4.29246377 -3.65109652e-14,4.74394203 C-3.65109652e-14,5.19542029 0.36654359,5.5613913 0.817871795,5.5613913 L2.71738974,5.5613913 C3.16871795,5.5613913 3.53526154,5.19542029 3.53526154,4.74394203 C3.53526154,4.29246377 3.16871795,3.92649275 2.71738974,3.92649275",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85927179,7.25281349e-14 C4.40794359,7.25281349e-14 4.04054359,0.365115942 4.04054359,0.816594203 L4.04054359,2.71143478 C4.04054359,3.16291304 4.40794359,3.52888406 4.85927179,3.52888406 C5.3106,3.52888406 5.678,3.16291304 5.678,2.71143478 L5.678,0.816594203 C5.678,0.365115942 5.3106,7.25281349e-14 4.85927179,7.25281349e-14",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90067179,3.79652174 L7.00115385,3.79652174 C6.54982564,3.79652174 6.18328205,4.16249275 6.18328205,4.61397101 C6.18328205,5.06544928 6.54982564,5.43142029 7.00115385,5.43142029 L8.90067179,5.43142029 C9.35285641,5.43142029 9.7194,5.06544928 9.7194,4.61397101 C9.7194,4.16249275 9.35285641,3.79652174 8.90067179,3.79652174",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.19498974,83.7971014 C8.19498974,83.7971014 9.31346154,91.756971 2.43406435e-14,91.5731304 C2.43406435e-14,91.5731304 7.99972821,91.6552174 7.78990769,99.1251304 C7.78990769,99.1251304 8.50929231,93.2482174 15.850441,91.9356812 C15.850441,91.9356812 9.64660513,93.3568116 8.19498974,83.7971014",
    id: "Fill-22-Copy-2",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.523195,44.4637681 C125.523195,44.4637681 126.64081,52.4236377 117.328205,52.2397971 C117.328205,52.2397971 125.327933,52.3218841 125.118113,59.790942 C125.118113,59.790942 125.836641,53.9148841 133.17779,52.6023478 C133.17779,52.6023478 126.97481,54.0234783 125.523195,44.4637681",
    id: "Fill-23-Copy-2",
    fill: "#63ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8356154,54.7246377 C26.8356154,54.7246377 27.2252821,57.4984928 23.9794872,57.4352174 C23.9794872,57.4352174 26.767959,57.4634348 26.6934513,60.0671304 C26.6934513,60.0671304 26.9443795,58.0192319 29.5033333,57.560913 C29.5033333,57.560913 27.3408974,58.056 26.8356154,54.7246377",
    id: "Fill-24-Copy-5",
    fill: "#0057B8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    stroke: "#0057B8",
    cx: 125.035897,
    cy: 2.56521739,
    rx: 2.06923077,
    ry: 2.06521739
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    stroke: "#005CC3",
    cx: 5.56666667,
    cy: 26.0797101,
    rx: 1.64102564,
    ry: 1.63768116
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-6",
    transform: "translate(150.728205, 80.376812)",
    fill: "#0057B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13589744,10.2608696 C7.42774649,10.2608696 6.85128205,10.8814599 6.85128205,11.6470481 L6.85128205,14.8616483 C6.85128205,15.6272364 7.42774649,16.2463768 8.13589744,16.2463768 C8.84404839,16.2463768 9.42051282,15.6272364 9.42051282,14.8616483 L9.42051282,11.6470481 C9.42051282,10.8814599 8.84404839,10.2608696 8.13589744,10.2608696",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60797679,6.84057971 L1.386895,6.84057971 C0.62156132,6.84057971 0,7.41480201 0,8.12318841 C0,8.8315748 0.62156132,9.4057971 1.386895,9.4057971 L4.60797679,9.4057971 C5.37331048,9.4057971 5.99487179,8.8315748 5.99487179,8.12318841 C5.99487179,7.41480201 5.37331048,6.84057971 4.60797679,6.84057971",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13589744,0 C7.42774649,0 6.85128205,0.619290427 6.85128205,1.38506407 L6.85128205,4.59899285 C6.85128205,5.36476649 7.42774649,5.98550725 8.13589744,5.98550725 C8.84404839,5.98550725 9.42051282,5.36476649 9.42051282,4.59899285 L9.42051282,1.38506407 C9.42051282,0.619290427 8.84404839,0 8.13589744,0",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8837839,6.84057971 L11.6634822,6.84057971 C10.8983339,6.84057971 10.2769231,7.41480201 10.2769231,8.12318841 C10.2769231,8.8315748 10.8983339,9.4057971 11.6634822,9.4057971 L14.8837839,9.4057971 C15.6503841,9.4057971 16.2717949,8.8315748 16.2717949,8.12318841 C16.2717949,7.41480201 15.6503841,6.84057971 14.8837839,6.84057971",
    id: "Fill-9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.849db0d34837ab02dba52a364b7d8120.svg";
export { ForwardRef as ReactComponent };